module.exports = __webpack_public_path__ + "static/fig4-597a02b302dbb4fc70d0b545e7fadda3.jpg";